import { render, staticRenderFns } from "./numstatistics.vue?vue&type=template&id=79630c11&scoped=true&"
import script from "./numstatistics.vue?vue&type=script&lang=js&"
export * from "./numstatistics.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=79630c11&lang=scss&scoped=true&"
import style1 from "./numstatistics.vue?vue&type=style&index=1&id=79630c11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79630c11",
  null
  
)

export default component.exports